// Code generated by protoc-gen-ts. DO NOT EDIT.
// protoc-gen-ts is an Art Processors production, found in mos-sdk-py.

import { Codec, DecodeContext, RemoteObject, WebRPCError, ensureScalar, stripTypePropertyDeep } from "generated/webrpc";

export namespace Date {
  export const refName = "mos.date.Date" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Year is astronomically numbered, as per ISO8601. See DateTime.year for
    // more details.
    readonly year: number,
    readonly month: number,
    readonly day: number,
  }
  export const defaults: Entity = {
    type: refName,
    year: 0,
    month: 0,
    day: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.date.Date");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["year"] = ensureScalar(ctx, v["year"], "number");
      out["month"] = ensureScalar(ctx, v["month"], "number");
      out["day"] = ensureScalar(ctx, v["day"], "number");
      return out as any as Entity;
    }
  }();
}

// Represents the half-closed interval '[from_date, to_date)' (i.e. to_date
// MUST be _exclusive_).
// 
// It may be valid on a per-use-case basis for one or both ends of the span
// to be missing; test for the presence of from_date and to_date using the
// 'HasField()' method (or, in the case of any of our wrapper generators,
// simply check for your platform's equivalent of 'null').
export namespace DateSpan {
  export const refName = "mos.date.DateSpan" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly fromDate: Date.Entity | undefined,
    readonly toDate: Date.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    fromDate: undefined,
    toDate: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      return stripTypePropertyDeep(v);
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.date.DateSpan");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["fromDate"] = ctx.decode(Date.codec, v["fromDate"], "fromDate");
      out["toDate"] = ctx.decode(Date.codec, v["toDate"], "toDate");
      return out as any as Entity;
    }
  }();
}

export namespace DateTime {
  export const refName = "mos.date.DateTime" as const;
  export type Entity = {
    readonly type: typeof refName,
    // Year is astronomically numbered, as per ISO8601. This means there is a
    // "Zero year". A value of "1" means the year "1 CE (AD)", while a value of
    // "-1" means the year "-2 BCE (BC)".
    readonly year: number,
    readonly month: number,
    readonly day: number,
    readonly hour: number,
    readonly minute: number,
    readonly second: number,
    readonly nano: number,
    readonly timeZone: TimeZoneOffset.Entity | string | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    year: 0,
    month: 0,
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
    nano: 0,
    timeZone: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["year"] = v.year;
      obj["month"] = v.month;
      obj["day"] = v.day;
      obj["hour"] = v.hour;
      obj["minute"] = v.minute;
      obj["second"] = v.second;
      obj["nano"] = v.nano;
      {
        const uv: any = v.timeZone;
        if (uv !== undefined) {
          if (uv.type == "mos.date.TimeZoneOffset") {
            obj["offset"] = TimeZoneOffset.codec.encode(uv);
          }
          else if (typeof(uv) === "string") {
            obj["timeZoneId"] = uv;
          }
          else {
            throw new WebRPCError("union discrimination failed for .mos.date.DateTime.time_zone");
          }
        }
      }
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.date.DateTime");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["year"] = ensureScalar(ctx, v["year"], "number");
      out["month"] = ensureScalar(ctx, v["month"], "number");
      out["day"] = ensureScalar(ctx, v["day"], "number");
      out["hour"] = ensureScalar(ctx, v["hour"], "number");
      out["minute"] = ensureScalar(ctx, v["minute"], "number");
      out["second"] = ensureScalar(ctx, v["second"], "number");
      out["nano"] = ensureScalar(ctx, v["nano"], "number");
      {
        if (v["offset"] !== undefined) {
          out["timeZone"] = ctx.decode(TimeZoneOffset.codec, v["offset"], "offset");
        }
        if (v["timeZoneId"] !== undefined) {
          out["timeZone"] = ensureScalar(ctx, v["timeZoneId"], "string");
        }
      }
      return out as any as Entity;
    }
  }();
}

// Represents the half-closed interval '[from_date_time, to_date_time)' (i.e.
// to_date_time MUST be _exclusive_).
// 
// It may be valid on a per-use-case basis for one or both ends of the span to
// be missing; test for the presence of from_date_time and to_date_time using
// the 'HasField()' method (or, in the case of any of our wrapper generators,
// simply check for your platform's equivalent of 'null').
export namespace DateTimeSpan {
  export const refName = "mos.date.DateTimeSpan" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly fromDateTime: DateTime.Entity | undefined,
    readonly toDateTime: DateTime.Entity | undefined,
  }
  export const defaults: Entity = {
    type: refName,
    fromDateTime: undefined,
    toDateTime: undefined,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const obj: RemoteObject = {};
      obj["fromDateTime"] = DateTime.codec.encode(v.fromDateTime);
      obj["toDateTime"] = DateTime.codec.encode(v.toDateTime);
      return obj;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.date.DateTimeSpan");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["fromDateTime"] = ctx.decode(DateTime.codec, v["fromDateTime"], "fromDateTime");
      out["toDateTime"] = ctx.decode(DateTime.codec, v["toDateTime"], "toDateTime");
      return out as any as Entity;
    }
  }();
}

export const DayOfWeekValues = new Set([
  'DAY_OF_WEEK_UNSPECIFIED' as const,
  'MONDAY' as const,
  'TUESDAY' as const,
  'WEDNESDAY' as const,
  'THURSDAY' as const,
  'FRIDAY' as const,
  'SATURDAY' as const,
  'SUNDAY' as const,
]);
export type DayOfWeek = typeof DayOfWeekValues extends Set<infer U> ? U : never;

// TimeZoneOffset indicates a fixed offset from UTC. Hours may be negative.
// 
// Examples:
// +10:00 == TimeZoneOffset{hour=10, minute=0}
// -04:00 == TimeZoneOffset{hour=-4, minute=30}
// 
export namespace TimeZoneOffset {
  export const refName = "mos.date.TimeZoneOffset" as const;
  export type Entity = {
    readonly type: typeof refName,
    readonly hour: number,
    readonly minute: number,
  }
  export const defaults: Entity = {
    type: refName,
    hour: 0,
    minute: 0,
  }
  export const codec: Codec<Entity> = new class {
    public encode(v: Entity): RemoteObject;
    public encode(v: Entity | undefined): RemoteObject | null {
      if (!v) return null;
      const { type, ...out } = v;
      return out;
    }
    public decode(v: RemoteObject): Entity;
    public decode(v: RemoteObject | null, ctx?: DecodeContext): Entity | undefined {
      if (v === undefined || v === null) return undefined;
      if (!ctx) ctx = new DecodeContext(".mos.date.TimeZoneOffset");
      if (typeof(v) !== "object") throw ctx.expected("object", v);
      const out: RemoteObject = { ...defaults };
      out["hour"] = ensureScalar(ctx, v["hour"], "number");
      out["minute"] = ensureScalar(ctx, v["minute"], "number");
      return out as any as Entity;
    }
  }();
}

